module.exports = __webpack_public_path__ + "img/parkeerdruk.e5500501.png";